import request from '@/utils/request';

/**
 * @description 查询账号管理列表
 * @param username
 * @param account
 * @param roleId
 * @param pageNum
 * @param pageSize
 */
function queryAccountList({ username, account, roleId, pageNum, pageSize } = {}) {
  return request({
    url: 'account/pageQueryAccountList',
    method: 'get',
    params: {
      username,
      account,
      roleId,
      pageNum,
      pageSize
    }
  });
}

/**
 * @description 按account手机号搜索账户
 * @param account 账户手机号
 * @returns {*}
 */
function queryAccountItem({ account } = {}) {
  return request({
    url: 'account/queryStaffDetail',
    method: 'get',
    params: { account }
  })
}

/**
 * @description 保存员工账号信息(新增 or 修改密码)
 * @param account
 * @param password
 * @param kdtName
 * @param roleName
 */
function saveAccountItem({ account, password, kdtName, roleName } = {}) {
  return request({
    url: 'account/saveAccount',
    method: 'post',
    data: {
      account,
      password,
      kdtName,
      roleName
    }
  });
}

/**
 * @description 删除账户
 * @param accountId
 */
function deleteAccountItem({ accountId } = {}) {
  return request({
    url: 'account/deleteAccount',
    method: 'post',
    data: {
      accountId
    }
  });
}

function getDownLoadTemplateFile() {
  return request({
    url: 'account/downloadAccountInfoTemplate',
    method: 'post',
    responseType: 'blob'
  });
}

/**
 * @description 导入账号数据
 * @param file
 */
function exportAccountData({ file }) {
  return request({
    url: 'account/importAccountInfo',
    method: 'post',
    data: {
      file
    },
    headers: { 'content-type': 'multipart/form-data' }
  });
}

/**
 * @description 根据账号ID查询账号信息
 * @param accountId
 * @returns {*}
 */
function queryAccountInfoById({ accountId } = {}) {
  return request({
    url: 'account/getAccount',
    method: 'get',
    params: { accountId }
  });
}

export default {
  queryAccountList,
  queryAccountItem,
  saveAccountItem,
  deleteAccountItem,
  getDownLoadTemplateFile,
  exportAccountData,
  queryAccountInfoById,
};
